import { useMutation } from '@apollo/react-hooks';
import { useContext, useEffect } from 'react';
import { SchedulingSessionStateContext } from '../../shared/components/SchedulingSessionState';
import { DILM_CLIENT_CONTEXT } from '../../shared/constants';
import widgetSessionOpenedMutation from './WidgetSessionOpenedMutation.graphql';

interface IProps {
  widgetId?: string | null | undefined;
}

export default function WidgetSessionOpenedMutation({ widgetId }: IProps) {
  const { widgetSessionOpenedTracked, setWidgetSessionOpenedTracked } = useContext(
    SchedulingSessionStateContext
  );
  const [widgetSessionOpened] = useMutation(widgetSessionOpenedMutation, {
    variables: { widgetId },
    context: DILM_CLIENT_CONTEXT,
  });

  useEffect(() => {
    if (widgetId && widgetId !== '(not set)' && !widgetSessionOpenedTracked) {
      widgetSessionOpened()
        .then(() => {
          setWidgetSessionOpenedTracked(true);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('Error With the `widgetSessionOpened` mutation', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widgetId]);

  return null;
}
